import { GenericSelectComponents as components } from '../../GenericSelectControl/GenericSelectControl';
import { withClassName } from '../helper';
export var LookupClearIndicator = withClassName(components.ClearIndicator, 'selectIcon', 'cancel');